module.exports = __webpack_public_path__ + "media/images/lp_small-02fcf9f48ddbe98e1b7461222d679653.webp";